import React, { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { PollForm } from '../components/PollModal';
import LoadingSpinner from '../components/ui/LoadingSpinner';

export default function PollPage() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  if (loading) return <LoadingSpinner fullPage />;

  if (!user) return (
    <div className="container py-5">
      <div className="alert alert-warning">Devi effettuare il login per rispondere al sondaggio.</div>
    </div>
  );

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-12 col-md-10 col-lg-8">
          <div className="text-center mb-4" style={{
            background: 'linear-gradient(90deg,#ffcc33,#ff9966)',
            padding: '1.25rem',
            borderRadius: 12,
            color: '#111'
          }}>
            <h2 className="mb-1">Sondaggio FantaWrestling</h2>
            <p className="mb-0">Il tuo feedback è prezioso per migliorare l'app.</p>
          </div>

          <div className="card shadow-sm">
            <div className="card-body">
              <p className="text-muted small mb-2">Tutte le risposte sono trattate in anonimato se non inserisci dati personali.</p>

              <PollForm user={{ uid: user.uid, email: user.email }} onFinish={() => { window.location.href = '/profile'; }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
